module.exports = __webpack_public_path__ + "img/H&S0302_SuperOk.ce199918.png";